<template>
  <div class="message">
    <div class="message_light" v-if="operate.getActionType().value == OperateType.light" :class="{ show: isShowDragTip }">
      {{ $t('message_mgx_des') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { LightModeType } from '@/define/light'
import { lightSet } from '@/service/driver/light_set'
import { OperateType, operate } from '@/service/driver/operate'
import { computed } from 'vue'

// 是否显示鼠标拖动的提示信息
const isShowDragTip = computed(() => {
  return lightSet.currentModeTypeTab.value == LightModeType.Custom || lightSet.modeName.includes('自定义')
})
</script>

<style lang="less" scoped>
.message {
  font-size: 36px;
  color: #fff;
  text-align: center;
  order: 2;
  margin-bottom: 20px;
}
.message_light {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  white-space: nowrap;
  transition: opacity 0.3s ease;
  z-index: 300;

  &.show {
    opacity: 1;
    pointer-events: auto;
  }
}
@media @y-md {
  .message {
    margin-bottom: 10px !important;
  }
}
</style>
